import { CLICK_SCENARIOS } from "../data/proposal";

const fmt = (n) => `NT$${n.toLocaleString("en-US")}`;

export const ClickForecast = ({ id, prices }) => (
  <div className="mt-6">
    <div className="overflow-x-auto rounded-2xl border border-[var(--line)]">
      <table data-testid={`${id}-forecast-table`} className="w-full min-w-[680px] whitespace-nowrap text-left">
        <thead className="bg-[var(--warm)] text-sm text-[var(--text)]">
          <tr>
            <th className="p-4">情境</th><th className="p-4">點擊（每月）</th><th className="p-4">預估訂房</th>
            {prices.map((p) => <th key={p.label} className="p-4">{p.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {CLICK_SCENARIOS.map((s) => (
            <tr key={s.name} data-testid={`${id}-row-${s.name}`} className="border-t border-[var(--line)]">
              <td className="p-4 font-bold text-[var(--ink)]">{s.name}</td>
              <td className="p-4 text-[var(--text)]">約 {s.clicks}<span className="text-xs text-[var(--muted)]">（{s.ctr}）</span></td>
              <td className="p-4 font-bold text-[var(--ink)]">約 {s.nights} 間夜<span className="text-xs font-normal text-[var(--muted)]">（{s.rate}）</span></td>
              {prices.map((p) => <td key={p.label} className="p-4 font-black text-[var(--teal-d)]">{fmt(s.nights * p.price)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="mt-3 text-sm text-[var(--muted)]">點擊 = 精準曝光 216,233 × 0.7%／0.85%／1%；訂房率沿用前面的 3%／5%／8%，每筆以 1 間房 1 晚計。</p>
  </div>
);
